import Vue from "vue"
import App from "@/App.vue"
import store from "@/store/index"
import router from "@/router/index"
import "@/registerServiceWorker"
import modal from "@/components/modal-comp"
import accountAPI from "@/plugins/accountAPI"

import Buefy from "buefy"
import VueFormulate from "@braid/vue-formulate"
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';

import "buefy/dist/buefy.css"

Vue.use(VueFormulate, {
  classes: {
    outer: 'field',
    wrapper: 'control',
    input: 'input'
  }
})
Vue.use(Buefy)
Vue.use(VueFilterDateFormat)
Vue.use(accountAPI)
Vue.component("modal", modal)

Vue.config.productionTip = false
Vue.config.debug = true

Vue.filter('convertToDate', function(value) {
  if (value) {
    return new Date(value);
  }
  else{
    return new Date();
  }
});

// Expose store globally for API access
window.store = store;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")
